module.exports = __webpack_public_path__ + "static/media/bmw.ee9ffee2.png";